// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"635":"f901c494","718":"111452ec"}[chunkId] + ".chunk.css";
};